import { alpha as MUIAlpha, darken as muiDarken, lighten as muiLighten } from '@mui/material/styles'
import type { BadgeColor } from '../components/Badge/types'
import type { ThemeMode } from '../components/theme/createPaletteBridge'

export { useTheme } from './useTheme'
export { styled, type CreateKuramaStyled } from './styled'
export { serializeCss } from './css'
export { escapeHtmlAttr } from './escapeHtmlAttr'
export type { AutocompleteString } from '../components/Autocomplete/types'

/**
 * The Alpha function is used to specify the opacity of a color. Read more about it here https://developer.mozilla.org/en-US/docs/Glossary/Alpha
 */

export const alpha = (color: string, value: number): string => {
  return MUIAlpha(color, value)
}

export type color = 'success' | 'error' | undefined

export const getInputBadgeColor = (color: color): BadgeColor => {
  if (color === 'success') {
    return 'success'
  }
  return 'error'
}

export const darken = (color: string, value: number): string => {
  return muiDarken(color, value)
}

export const lighten = (color: string, value: number): string => {
  return muiLighten(color, value)
}

/**
 * Move a color toward (positive offset) or away from (negative offset) the page background.
 * Light mode fades by lightening; dark mode fades by darkening.
 */
export const fadeColor = (color: string, offset: number, mode: ThemeMode): string => {
  const amount = Math.abs(offset)
  if (mode === 'dark') {
    return offset < 0 ? lighten(color, amount) : darken(color, amount)
  }
  return offset < 0 ? darken(color, amount) : lighten(color, amount)
}
